import { cloneDeep } from 'lodash';

import { createReducer } from '@topconagriculture/frontend-utils';

import { IngredientDryMatters } from './appIngredients.types';
import { getIngredientDrymatters } from './appIngredients.actions';

export type appIngredientsState = {
  dryMatters: IngredientDryMatters[];
  orderControlIsEnabled: boolean;
};

export const initialState: appIngredientsState = {
  dryMatters: [],
  orderControlIsEnabled: false,
};

const appIngredientsReducer = createReducer(initialState, {
  [getIngredientDrymatters.done.type]: (
    state: appIngredientsState,
    action: ReturnType<typeof getIngredientDrymatters.done>,
  ) => {
    const data = cloneDeep(state.dryMatters);
    const { params: ingredientId, result: dryMatters } = action.payload;
    const ingrPrices = data.find((ip) => ip.ingredientId === ingredientId);
    if (ingrPrices) {
      ingrPrices.dryMatters = dryMatters;
    } else {
      data.push({ ingredientId, dryMatters });
    }
    return {
      ...state,
      dryMatters: data,
    };
  },
});

export default appIngredientsReducer;
